"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PropertyShowcase() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="152004" id="htmlwidget" className="bg-background relative py-16 md:py-24 overflow-hidden">
            {}
            <div className="absolute inset-0 bg-card/40" />

            <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
                    {}
                    <div className="flex flex-col h-full">
                        <div className="mb-4">
                            <h3 className="font-sans text-2xl sm:text-3xl font-bold uppercase tracking-wider text-primary mb-1">
                                3D Virtual Tours
                            </h3>
                            <p className="font-sans text-sm font-semibold uppercase tracking-wide text-secondary-600">
                                Immersive Orlando Property Exploration
                            </p>
                        </div>
                        <div className="relative w-full bg-background rounded-xl shadow-xl border border-border overflow-hidden aspect-video lg:aspect-auto lg:h-[400px]">
                            <iframe src="https://my.matterport.com/show/?m=WAMEPDS2GX5" className="absolute inset-0 w-full h-full border-0" allowFullScreen allow="xr-spatial-tracking" title="3D Virtual Tour" />
                        </div>
                    </div>

                    {}
                    <div className="flex flex-col h-full">
                        <div className="mb-4">
                            <h3 className="font-sans text-2xl sm:text-3xl font-bold uppercase tracking-wider text-primary mb-1">
                                Professional Layouts
                            </h3>
                            <p className="font-sans text-sm font-semibold uppercase tracking-wide text-secondary-600">
                                Precision measurements for every listing
                            </p>
                        </div>
                        <div className="relative w-full bg-white rounded-xl shadow-xl border border-border flex items-center justify-center p-4 aspect-video lg:aspect-auto lg:h-[400px]">
                            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608256/img/detailed_floorplan_lidar.png" alt="Detailed Floor Plan" className="w-full h-full object-contain drop-shadow-sm" />
                        </div>
                    </div>
                </div>
            </div>
        </section>;
}